<template>
  <div class="home">
    <h1>Welcome to JavaScript Framework Watcher!</h1>
    <h3>Here, you can keep up to date with some of JavaScript's most popular frameworks:</h3>
    <h3>Vue, Angular, Ember, Svelte, React</h3>
    <h3>Tracked are each frameworks Watcher, Starred and Forked count via Github.</h3>
    <img
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpgta8UVTzXLRy-48RzGIiyoOkqStpozFO_g&usqp=CAU"
      alt=""
    />
  </div>
</template>

<style></style>

<script>
export default {
  data: function () {
    return {};
  },
  created: function () {},
  methods: {},
};
</script>
